<template>
  <el-dialog
    height="350"
    :visible="visible"
    :width="isMobile ? '300px' : '675px'"
    append-to-body
    :close-on-click-modal="false"
    class="status-modal"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <loader-wrapper :loading="loading">
      <p style="color: #409eff">
        <b>Добавить контрагента:</b>
      </p>
      <el-form class="demo-ruleForm">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Название организации">
              <el-input
                v-model="contragent_data.org_name"
                placeholder="ООО 'Название организации'"
                :readonly="true"
              />
            </el-form-item>
            <el-form-item label="Адрес организации">
              <el-input
                v-model="contragent_data.address"
                type="textarea"
                :rows="2"
                placeholder="Адрес организации"
              />
            </el-form-item>
            <el-form-item label="Телефон">
              <el-input
                v-model="contragent_data.phone"
                v-mask="'+7 (###) ###-##-##'"
                type="text"
                placeholder="Контактный телефон"
              />
            </el-form-item>
            <el-form-item label="E-mail">
              <el-input
                v-model="contragent_data.email"
                type="mail"
                placeholder="Адрес почтового ящика"
              />
            </el-form-item>
            <el-form-item label="БИК">
              <el-input
                v-model="contragent_data.bik"
                type="text"
                placeholder="БИК"
              />
              <el-button
                type="success"
                style="margin-top: 8px"
                plain
                @click="checkBik"
              >
                Проверить БИК
              </el-button>
            </el-form-item>
            <el-form-item label="Название банка">
              <el-input
                v-model="contragent_data.name_bank"
                type="textarea"
                :rows="2"
                :readonly="true"
                placeholder="Название банка"
              />
            </el-form-item>
            <el-form-item label="Коресподентский счет">
              <el-input
                v-model="contragent_data.core_account"
                :readonly="true"
                placeholder="Кор. счет"
              />
            </el-form-item>
            <el-form-item label="Номер счета">
              <el-input
                v-model="contragent_data.checking_account"
                placeholder="Номер счета"
                @blur="checkRs"
              />
              <div v-if="errorRs.code > 0" style="padding-top: 5px; color: red">
                {{ errorRs.message }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        style="
          display: flex;
          justify-content: flex-end;
          padding-top: 20px;
          margin-top: 20px;
          border-top: 0.5px solid grey;
        "
      >
        <span slot="footer" class="dialog-footer">
          <!--          <el-button-->
          <!--            style="width: 63%"-->
          <!--            type="primary"-->
          <!--            @click="saveContragent(true)"-->
          <!--          >-->
          <!--            Сохранить и перейти к документам-->
          <!--          </el-button>-->
          <el-button
            type="success"
            style="width: 100%"
            @click="saveContragent(false)"
          >
            Сохранить
          </el-button>
        </span>
      </div>
      <passport-user-organization
        :id="showPassportId"
        :dialog-visible="dialogVisible"
        :close-modal="onCloseOrg"
        @create="onCreateOrg"
      />
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapMutations } from 'vuex'
import { validateRs } from '@/helpers/validate-req'
import PassportUserOrganization from '@/components/Forms/PassportUserOrganization'
import getError from '@/api/getErrors'

const Contragents = RepositoryFactory.get('contragents')
const Check = RepositoryFactory.get('check')

export default {
  name: 'ContragentModalInProgress',
  components: { LoaderWrapper, PassportUserOrganization },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    response: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      errorRs: {
        code: 0,
        message: '',
      },
      contragent_data: {
        user_id: this.$store.state.userProfile.id,
        user_org_inn: this.$store.state.userProfile.current.organization.inn,
        inn: this.org ? this.org.inn : '',
        org_name: '',
        phone: '',
        email: '',
        address: '',
        address_kladr: '',
        bik: '',
        name_bank: '',
        core_account: '',
        checking_account: '',
      },
      contract: {
        sourceModelName: 'contragents',
        sourceId: 0,
        documentType: 'auto_sts', // СРСТ
      },
      ifInnError: false,
      dialogVisible: false,
      showPassportId: null,
      loading: false,
    }
  },

  methods: {
    ...mapMutations(['createContragent']),
    ...mapMutations({
      updateResponsesInProgress: 'loadDay/updateResponsesInProgressByInn',
    }),
    onCloseOrg() {
      this.dialogVisible = false
    },
    onCreateOrg(contr) {
      this.onCloseOrg()

      if (contr) {
        this.$emit('edited', contr, 1)
      }
    },
    checkRs() {
      if (this.contragent_data.checking_account) {
        this.contragent_data.checking_account =
          this.contragent_data.checking_account.replace(/\s/g, '')
      }

      return validateRs(
        this.contragent_data.checking_account,
        this.contragent_data.bik,
        this.errorRs,
      )
    },
    checkBik() {
      Check.bik(this.contragent_data.bik).then(response => {
        if (response.data && !response.data.error) {
          this.contragent_data.name_bank = response.data.name
            .split('&quot;')
            .join("'")
          this.contragent_data.core_account = response.data.ks
        } else {
          this.contragent_data.name_bank = 'Банк не найден'
        }
      })
    },
    isErrors(data) {
      const error = getError.isError(data)

      if (error.isError) {
        this.$alert(error.message)

        return true
      }

      return false
    },
    saveContragent(docs = false) {
      if (this.checkRs()) {
        Contragents.postContragents(this.contragent_data)
          .then(response => {
            if (response.status === 201) {
              this.createContragent(response.data)
              this.$message({
                message: 'Контрагент добавлен успешно',
                type: 'success',
              })
              this.updateResponsesInProgress(response.data)
              this.beforeClose()
              this.$emit('close')

              if (docs) {
                this.contragent_data.id = response.data.id
                this.toEdit()
              }
            }
          })
          .catch(e => {
            this.isErrors(e)
          })
      } else {
        this.$message.warning(this.errorRs.message)
      }
    },
    clearDialogForm() {
      for (let key in this.contragent_data) {
        if (!['user_id', 'user_org_inn'].includes(key)) {
          this.contragent_data[key] = ''
        }
      }
      this.ifInnError = false
    },
    beforeOpen() {
      this.contragent_data.org_name = this.response.organization_name
      this.contragent_data.inn = this.response.organization_inn
      this.contragent_data.phone = this.response.request_phone
    },
    beforeClose() {
      this.clearDialogForm()
      this.loading = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="sass">
.status-modal
  .row-wrap
    margin-bottom: 8px
  .action-btn
    min-width: 130px
  .set-date-wrap
    display: flex
    justify-content: flex-start
    align-items: center
    margin-top: 8px
    .el-date-editor
      min-width: 270px
  .el-dialog__body
    color: #000
    *
      font-family: 'Rubik', sans-serif
    .date-at
      color: #67C23A
      font-size: 16px
      font-weight: bold
      margin-top: 8px
      margin-bottom: 4px
    .resp-time
      font-size: 14px
      font-weight: normal
      color: #98A9BC
      margin: 4px 0px
      text-transform: lowercase
    span
      font-size: 16px
      text-transform: uppercase
    p
      font-size: 16px
      text-transform: uppercase
      margin-bottom: 0px
      margin-top: 0px
      &.first
        text-transform: uppercase
        margin: 0px 0px 0px 40px
    .el-timeline-item
    .el-timeline-item__content
      font-size: 14px
      font-weight: bold
      margin-top: 8px
      color: #000
      button
        margin-left: 10px
    .el-timeline-item__node
      border: 1px solid
    .el-timeline-item__timestamp
      margin-left: -30px
      margin-top: 8px!important
      font-size: 14px
      font-weight: normal
      color: #98A9BC
      margin: 0px
    .set-btn
      display: flex
      margin-left: 10px
    .date
      font-size: 15px
      line-height: 14px
      color: #8694A4
      margin: 10px 0
      &.status
        text-decoration: underline
      &.info
        color: #909399
      &.success
        font-size: 16px
        font-weight: bold
        margin-left: 12px
        color: #67C23A
      &.warning
        color: #E6A23C
      &.danger
        color: #F56C6C
</style>
